import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';


const BASE_URL = process.env.REACT_APP_MAIN_URL

export const AddGPU = createAsyncThunk(
  "other/AddGPU",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/gpu-create/`, data)
    return response.data
  }
); 

export const UpdateGPU = createAsyncThunk(
  "other/UpdateGPU",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/gpu-update/${data.id}/`, data)
    return response.data
  }
);

export const GetGPUList = createAsyncThunk(
  "user/GetGPUList",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/gpu-list/`)
    return data
  }
);

export const DeleteGPU = createAsyncThunk(
  "other/DeleteGPU",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/gpu-delete/${id}/`)
    if (response.status === 226){
      toast.warning(response.data.message)
    }
    return response.status
  }
);

